import { Sparkles } from 'lucide-react';
import type { ScoredSurvey } from '../lib/surveyRanking';

/**
 * L3+ elevated-payout extras, rendered inline next to the prominent $ figure:
 *   - the BASE rate struck through (shown whenever there's an elevated bonus), and
 *   - a violet trust-bonus pill with the DOLLAR increase (e.g. "+$0.75"), shown
 *     only when the bonus is >= $0.05 (showElevatedBadge) so we never render a
 *     hollow "+$0.02" badge.
 *
 * Renders NOTHING for L1-L2 / no-bonus surveys, so every caller falls back to its
 * plain single-number layout unchanged. Shared by the wall grid + hero cards and
 * the dashboard preview cards — all fed by scoreSurveys(), which reuses the
 * per-request configured rates (no per-card config read).
 */
export function ElevatedPayoutExtras({ survey }: { survey: ScoredSurvey }) {
  if (!survey.hasElevatedBonus) return null;
  return (
    <>
      <span className="text-sm text-[#9CA3AF] line-through tabular-nums" aria-label="base payout">
        ${survey.baseCashValue}
      </span>
      {survey.showElevatedBadge && (
        <span
          className="inline-flex items-center gap-0.5 text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#7C6CFF] text-white"
          title="Higher payout for your trust level"
        >
          <Sparkles className="w-3 h-3" />+${survey.elevatedBonusDelta.toFixed(2)}
        </span>
      )}
    </>
  );
}
